import { useApiResource } from './useApiResource';

import { QueryParams, UpdateQueryParams, useQueryParams, UseQueryParamsOptions } from '.';

export type QueryResourceApiTransform<P> = (params: P) => P;

export type UseQueryResourceOptions<P> = UseQueryParamsOptions<P> & {
	apiTransform?: QueryResourceApiTransform<P>;
	uri?: string;
};

export interface UseQueryResourceResult<R, P> {
	loading: boolean;
	queryParams: P;
	resource?: R;
	updateParams: UpdateQueryParams<P>;
}

export function useQueryResource<R, P extends QueryParams>(
	options?: UseQueryResourceOptions<P>
): UseQueryResourceResult<R, P> {
	const { uri, apiTransform, ...queryOptions } = options || {};
	const { queryParams, updateParams } = useQueryParams<P>(queryOptions);
	const { loading, resource } = useApiResource<R>(uri, apiTransform ? apiTransform(queryParams) : queryParams);

	return {
		loading,
		queryParams,
		resource,
		updateParams
	};
}
